import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { ProcessType } from '../../Constants/Enums/Client/DashboardFilter/ProcessType';
import { WrapCashContributionModel } from '../../Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class WrapCashContributionInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, headAccountHierarchyId: string, activityType: ProcessType): Promise<ValidatedResult<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WrapCashContributionInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId, activityType: activityType }

    return AjaxWrapper.post<ValidatedResult<string>, any>(url, data);
  }
  public get(hierarchyId: string, customerId: number, editAction: string, batchId: number): Promise<WrapCashContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WrapCashContributionInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, customerId: customerId, editAction: editAction, batchId: batchId }

    return AjaxWrapper.get<WrapCashContributionModel, any>(url, data);
  }
  public put(model: WrapCashContributionModel): Promise<WrapCashContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WrapCashContributionInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.put<WrapCashContributionModel, any>(url, data);
  }
  public delete(hierarchyId: string): Promise<ServiceValidationError, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WrapCashContributionInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.delete<ServiceValidationError, any>(url, data);
  }
}

